export default "__VITE_ASSET__a97e3821__"